interface ApiErrorResponse {
    status: number;
    error: {
        message?: {
            defaultMessage?: string;
            arguments?: unknown[];
        };
        defaultMessage?: string;
    };
}

function isApiErrorResponse(value: unknown): value is ApiErrorResponse {
    return (
        typeof value === 'object' &&
        value !== null &&
        'status' in value &&
        'error' in value
    );
}

export function extractApiErrorMessage(
    err: unknown,
    fallback = 'Unknown error'
): string {
    if (isApiErrorResponse(err)) {
        const { error } = err;
        if (error.message?.defaultMessage) return error.message.defaultMessage;
        const args = error.message?.arguments;
        if (
            Array.isArray(args) &&
            args.length > 0 &&
            typeof args[0] === 'string'
        ) {
            return args[0];
        }
        if (error.defaultMessage) return error.defaultMessage;
    }
    if (err instanceof Error && err.message) return err.message;
    return fallback;
}
